import "./HelpButton.scss"

import React, { FunctionComponent } from "react"

import iconHelp from "assets/img/icon-help.svg"

import Tooltip, { ITooltipProps } from "components/Tooltip/Tooltip"

export interface IHelpButtonProps {
    tooltipProps?: Omit<ITooltipProps, "children">
}

const HelpButton: FunctionComponent<React.PropsWithChildren<IHelpButtonProps>> = ({
    tooltipProps
}) => {
    return (
        <Tooltip
            {...tooltipProps}>
            <button
                type="button"
                className="help-button"
                aria-label="?"
                data-testid="help-button">
                <img src={iconHelp} alt="?" />
            </button>
        </Tooltip>
    )
}

export default HelpButton
